import axios from '@/utils/api.request'
import { stringify } from 'qs';
import tags from "@/components/Use/tags";

export const queryChat=(data)=>{
    return axios.request({
        url: '/question',
        data,
        method: 'post'
    })
}

export const queryPoke=()=>{
    return axios.request({
        url: '/poke',
        method: 'get'
    })
}

export const getNotice=(data)=>{
    return axios.request({
        url: '/notice-list',
        data,
        method: 'get'
    })
}

export const getRelate=(data)=>{
    return axios.request({
        url: '/search',
        data,
        method: 'post'
    })
}


export const userLog=(data)=>{
    return axios.request({
        url: '/log',
        data,
        method: 'post'
    })
}



export const setUser=(data)=>{
    return axios.request({
        url: '/set-userInfo',
        data,
        method: 'post'
    })
}


export const setPosition=(data)=>{
    return axios.request({
        url: '/set-position',
        data,
        method: 'post'
    })
}

export const queryComment=(data)=>{
    return axios.request({
        url: `/news/discuss-news?${stringify(data)}`,
        method: 'GET'
    })
}

export const discussNews=(data)=>{
    return axios.request({
        url: '/news/user-discuss',
        data,
        method: 'post'
    })
}


//其它新闻
export const discussNewsOther=(data)=>{
    return axios.request({
        url: `/news/sim-news?${stringify(data)}`,
        method: 'get'
    })
}


/*热点新闻*/

export const getHotTopic=()=>{
    return axios.request({
        url: '/news/hot-topic',
        method: 'get'
    })
}

export const getHotTopicDesc=(data)=>{
    return axios.request({
        url: `/news/hot-topic-desc?${stringify(data)}`,
        method: 'get'
    })
}

export const getHotTopicNews=(data)=>{
    return axios.request({
        url: `/news/hot-topic-news?${stringify(data)}`,
        method: 'get'
    })
}

export const getHotNews=()=>{
    return axios.request({
        url: '/news/hot-news',
        method: 'get'
    })
}

export const getSceneCommon=()=>{
    return axios.request({
        url: '/news/scene-common',
        method: 'get'
    })
}

export const getSceneMultiProcess=()=>{
    return axios.request({
        url: '/scene-multi-process',
        method: 'get'
    })
}

/**
 * 多流程
 * @param data
 */
export const queryMultiProgress=(data)=>{
    return axios.request({
        url: '/multi-process',
        data,
        method: 'post'
    })
}

/**
 * 旅游场景
 */
//选择查询数据源
export const queryTourism=()=>{
    return axios.request({
        url: '/tourism/click-data',
        method: 'get'
    })
}

//推荐景点
export const queryTourSight=(data)=>{
    console.info('data',data)
    return axios.request({
        url: `/tourism/sight-list`,
        data,
        method: 'post'
    })
}

//获取景点详情
export const queryTourDetail=(data)=>{
    return axios.request({
        url: `/tourism/sight-detail?${stringify(data)}`,
        method: 'get'
    })
}

//我想去玩
export const queryTourGo=(data)=>{
    return axios.request({
        url: `/tourism/sight-go?${stringify(data)}`,
        method: 'get'
    })
}

/*不感兴趣*/
export const queryTourCommon=()=>{
    return axios.request({
        url: `/tourism/scene-common`,
        method: 'get'
    })
}


/*听生活场景*/
//快速导航组件
export const queryAudio = ()=>{
    return axios.request({
        url: '/audio/category/list',
        method: 'get'
    })
}
//获得封面播放列表
export const queryAudioList = (id) => {
    return axios.request({
        url: `/audio/track/list?${stringify(id)}`,
        method: 'get'
    })
}

//获得喜马拉雅播放列表
export const queryXimalayaList = (id) => {
    return axios.request({
        url: `/audio/albums/browse?${stringify(id)}`,
        method: 'get'
    })
}

// 边听边玩接口
export const audioAndPlay = () => {
    return axios.request({
        url: '/audio/play',
        method: 'get'
    })
}

// 看看其他栏目 等音乐按钮
export const queryAudioBtn = (id) => {
    return axios.request({
        url: `/audio/data?${stringify(id)}`,
        method: 'get'
    })
}

//重进生活场景
export const enterAudio = () => {
    return axios.request({
        url: '/audio/reload',
        method: 'get'
    })
}

//音频场景搜索
export const queryAudioSearch = (words) => {
    return axios.request({
        url: `/audio/search/all?${stringify(words)}`,
        method: 'get'
    })
}

//音频场景不感兴趣
export const queryAudioScene = () => {
    return axios.request({
        url: '/audio/scene-common',
        method: 'get'
    })
}

//获得活动列表
export const getActivityList = () => {
    return axios.request({
        url: '/activity/list',
        method: 'get'
    })
}

//活动假用户
export const getFakeUser = () => {
    return axios.request({
        url: '/activity/user',
        method: 'get'
    })
}

//活动场景中的不感兴趣
export const getActivityScene = () => {
    return axios.request({
        url: '/activity/scene-common',
        method: 'get'
    })
}

//分享活动
export const shareActivity = (id) => {
    return axios.request({
        url: `/activity/share?${stringify(id)}`,
        method: 'get'
    })
}

//获得活动二维码
export const getQRCode = (id, longpress) => {
    return axios.request({
        url: `/activity/share-result?${stringify(id, longpress)}`,
        method: 'get'
    })
}

// 退出功能反馈
export const exitfeedback=()=>{
    return axios.request({
        url: '/feedback-exit',
        method: 'get'
    })
}
// 功能反馈信息
export const feedbackData=(data)=>{
    return axios.request({
        url: '/user-feedback',
        data,
        method: 'post'
    })
}
// 获取功能反馈子目录
export const feedbackSublist=(data)=>{
    return axios.request({
        url: '/feedback-sublist',
        data,
        method: 'post'
    })
}
// 上传音频
export const sendAudiorecorder=(data)=>{
    // console.log("sendAudiorecorder=====",data)
    return axios.request({
        url: '/speech-question',
        data,
        method: 'post'
    })
}
// 上传音频之后再请求
export const sendAudiorecorderQuestion=(data)=>{
    // console.log("sendAudiorecorder=====",data)
    return axios.request({
        url: '/speech',
        data,
        method: 'post'
    })
}